import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('TransactionLog', {params});
    }, 
    export(params) {
        return Service().get('TransactionLog/export/', {params});
    },    
}